import { render, staticRenderFns } from "./SliderPopup.vue?vue&type=template&id=995e7fee&scoped=true&"
import script from "./SliderPopup.vue?vue&type=script&lang=js&"
export * from "./SliderPopup.vue?vue&type=script&lang=js&"
import style0 from "./SliderPopup.vue?vue&type=style&index=0&id=995e7fee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995e7fee",
  null
  
)

export default component.exports